import { CONFIG } from '../environments/environment';


export const VERSIONCONFIG = {
    path: CONFIG.migrateAppV2 ? '' : 'v2',
    redirectPrefix: CONFIG.migrateAppV2 ? '' : 'v2/',
    bootstrapPath: CONFIG.migrateAppV2 ? '' : '/v2'
};
